<div echarts [options]="chartOptions()" (chartClick)="onChartClick($event)" class="dot-plot-chart"></div>
